import { render, staticRenderFns } from "./PayedInvoicesBarChart.vue?vue&type=template&id=0644c48c&"
import script from "./PayedInvoicesBarChart.vue?vue&type=script&lang=js&"
export * from "./PayedInvoicesBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports